import { useQuery } from "react-query";
import api from "../api";

export const useGetUserAsset = () => {
  return useQuery(["assets"], () => {
    return api.get("/assets").then((res) => res.data);
  });
};
